import { canParseImage, parseImage, parseToImageBitmap, loadToHTMLImage } from './lib/parse-image';
var EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'ico', 'svg'];
var MIME_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/bmp', 'image/vndmicrosofticon', 'image/svg+xml'];
export default {
  name: 'Images',
  mimeTypes: MIME_TYPES,
  extensions: EXTENSIONS,
  parse: canParseImage && parseImage,
  loadAndParse: typeof Image !== 'undefined' && loadToHTMLImage
};
export var ImageBitmapLoader = {
  mimeTypes: MIME_TYPES,
  extensions: EXTENSIONS,
  parse: parseToImageBitmap
};
export var HTMLImageLoader = {
  mimeTypes: MIME_TYPES,
  extensions: EXTENSIONS,
  loadAndParse: loadToHTMLImage
};
//# sourceMappingURL=image-loader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@loaders.gl/images/dist/esm/image-loader.js
// module id = 1413
// module chunks = 0